var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikesLarge1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.612 5.41452C18.7238 4.50884 17.5188 4 16.2623 4C15.0058 4 13.8008 4.50884 12.9126 5.41452L11.9998 6.34476L11.087 5.41452C9.23698 3.52912 6.23752 3.52912 4.38751 5.41452C2.5375 7.29991 2.5375 10.3567 4.38751 12.2421L5.30029 13.1724L11.9998 20L18.6992 13.1724L19.612 12.2421C20.5007 11.3369 21 10.1088 21 8.82833C21 7.54781 20.5007 6.31977 19.612 5.41452Z",
    fill: "black",
    fillOpacity: 0.4,
    stroke: "white",
    strokeWidth: 1.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikesLarge1);
export default __webpack_public_path__ + "static/media/likes-large 1.aadefcf30345431ea47a3882f28f6f14.svg";
export { ForwardRef as ReactComponent };